import { createTransform } from 'redux-persist';
import { tierCountOf } from 'Utils/LevelTierCount';

/**
 * MUS-651: the stored tier count comes back as a count or null. Earlier
 * versions stored the raw tier list there, or a 1 that stood for "not known".
 * The list becomes its length; a 1 is still a 1, and the lesson's own tier
 * list corrects it once the level's list loads.
 */
export const lessonTierCountTransform = createTransform<unknown, unknown>(
  (stored) => stored,
  (restored) => tierCountOf(restored),
  { whitelist: ['currentLevelTiers'] },
);
